import dayjs from 'dayjs';

import { API_DATE_FORMAT } from './date';

export const TRASPORT_METHOD_DELIVERY = 'DEL';
export const DEFAULT_TRANSPORT_METHOD = TRASPORT_METHOD_DELIVERY;
export const MIXED_TRANSPORT_METHOD = 'BTH';
export const CROP_MIN_DELIVERY_DATE = dayjs().add(1, 'day').format(API_DATE_FORMAT); // date
